import { sortBy } from "lodash";
import { BASE_ROUTE } from "../config";

Date.prototype.addDays = function (days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}
export function logout(){
    
    window.localStorage.removeItem('user_info_company');
    window.location.href = `${BASE_ROUTE}/login`;
}
export function createTimeObject(raw) {
    let r;
    if(typeof raw === 'string'){
        r = new Date(raw.replace(/-/g, '/'));
    }else if(raw instanceof Date){
        r = raw;
    }else{
        r = new Date();
    }
    let y = r.getFullYear();
    let m = ("00" + (r.getMonth() + 1)).substr(-2);
    let d = ("00" + r.getDate()).substr(-2);
    let h = ("00" + r.getHours()).substr(-2);
    let i = ("00" + r.getMinutes()).substr(-2);
    let s = ("00" + r.getSeconds()).substr(-2);
    return { y, m, d, h, i, s };
}
export function createTimeString(format = '', raw = undefined) {
    let datetime_object = createTimeObject(raw);
    let output = '';
    for (let i in format) {
        let char = format[i];
        output += datetime_object[char] || char;
    }
    return output;
}
export function getDates(startDate, stopDate) {
    var dateArray = new Array();
    var currentDate = startDate;
    while (currentDate <= stopDate) {
        dateArray.push(new Date(currentDate));
        currentDate = currentDate.addDays(1);
    }
    return dateArray;
}
export function numberWithComma(number = 0) {
    if (isNaN(number)) {
        console.warn('not a numeric arg');
        return '$0';
    }
    let p = number < 0 ? '-' : '';
    let s = Math.abs(number).toString();
    let f = s.replace(/(\.+\d+)$/, '');
    let b = s.replace(/^(\d+)/, '');
    let output = '';
    let d = 0;
    for (let i = f.length - 1; i >= 0; i--) {
        d++;
        let c = f[i];
        output = c + output;
        if (d > 0 && d % 3 == 0 && d !== f.length) output = ',' + output;
    }
    return `${p}${output}${b}`;
}
export function numberToCash(number = 0) {
    return '$' + numberWithComma(number);
}

export function calculateDiscount(product){
    let q1 = (product.price == 0);
    let q2 = (product.discount_price == 0);
    let q3 = (product.price == product.discount_price);
    let q4 = (!product.discount_price || !product.price);
    let q5 = (!product.product_discount);
    if(q1 || q2 || q3 || q4 || q5){
        product.discount_rate = null;
        product.discount_expiration = new createTimeObject();
    }else{
        product.discount_rate = (product.discount_price / product.price).toFixed(2) * 100;
        if(product.discount_rate > 10 && (product.discount_rate % 10 === 0)) product.discount_rate /= 10;
        product.discount_expiration = new createTimeObject(product.product_discount.end_date);
    }
    return product;
}
export function bySort(a, b){
    if(a.sort > b.sort) return 1;
    if(a.sort === b.sort) return 0;
    return -1;
}

export function isNumeric(str) {
    if (typeof str != "string") return false  
    return !isNaN(str) && !isNaN(parseFloat(str))
}
export function getUserInfo(){
    return JSON.parse(localStorage.getItem('user_info_company') || '{}');
}
export function auth(module_code){
    const user_info = getUserInfo();
    if(user_info.is_admin) return true;
    return (user_info.permissions || []).find(p=>p.code == module_code) ? true : false;
}
export function getOrderStatus(temp_no, result){
    if(temp_no === undefined && result === undefined) return '尚未签收';
    if(temp_no !== null) return '签收成功';
    if(temp_no === null && result === null) return '尚未签收';
    if(temp_no === null && result !== null) return '签收失败';
}
export function getInvoiceStatus(audit){
    if(audit == 1) return '通过';
    if(audit == 0) return '未通过';
    if(audit == undefined) return '';
    return '审核中';
}
export function sortByTime(arr, column){
    return sortBy(arr, function(row){ return (new Date((row[column] || row.date).replace(/-/g, '/'))).getTime() * -1; });
}
export default { logout, createTimeObject, createTimeString, getDates, numberWithComma, numberToCash, bySort, isNumeric, getUserInfo, auth };